import React from 'react';

import { withBlockRendering } from '../common/Block.jsx';
import Defaults from '../layout/Defaults.jsx';
import { FormContainer, withValidationV2 } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';

function _Component(props) {
    // Content Properties
    let className = 'cont--whitelabel';
    // if (props.builder) {
    //     className += ' builder';
    // }
    const contentProps = {
        className,
        id: props.id,
        // onDragOver: (e) => { if (e) { e.preventDefault() } },
        // onDrop: props.onDrop
    }
    const pageConfig = Defaults.PageConfig[PageType.PasswordProtection]();
    // let pageConfig = props.contentConfig || props.pageConfig;
    // if (!props.builder && !pageConfig) {
    //     pageConfig = Defaults.PageConfig[PageType.PasswordProtection](props.config);
    // }
    // let containerProps;
    // if (props.onPageProps) {
    //     containerProps = props.onPageProps();
    // } else if (pageConfig.desktop) {
    //     containerProps = pageConfig.desktop.page;
    // }

    // Block Rendering
    let blocks = [];
    if (pageConfig.desktop && pageConfig.desktop.blocks) {
        blocks = pageConfig.desktop.blocks;
    }
    const style = { height: '100%', overflow: 'auto' }
    const backgroundColor = style.backgroundColor || props.config && props.config.colors && props.config.colors.bodyBackground;
    const renderedBlocks = props.onBlockRendering(
        props.pageType,
        blocks,
        (d) => {
            if (!d.type) {
                return;
            }
            const blockProps = { backgroundColor };
            switch (d.type.value) {
                case Name.Block.PasswordForm.Container:
                    blockProps.editor = false;
                    blockProps.pageId = props.pageId;
                    blockProps.recaptcha = props.recaptcha;
                    blockProps.onComplete = props.onComplete;
                    break;
            }
            return blockProps;
        }
    );
    return (
        <div {...contentProps} style={style}>
            {renderedBlocks}
        </div>
    )
    // let content = renderedBlocks;
    // content = (
    //     <div style={style}>
    //         {
    //             props.editor &&
    //             <PageTopHiddenDraggable offset={topHiddenOffset} pageEmpty={!renderedBlocks || renderedBlocks.length == 0} onDragEnter={props.onDragEnter} />
    //         }
    //         {content}
    //         {
    //             props.editor &&
    //             <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
    //         }
    //     </div>
    // );
    // if (props.editor) {
    //     return <EditorContainerWrapper {...contentProps}>{content}</EditorContainerWrapper>
    // }
    // return <div {...contentProps}>{content}</div>
}
const Component = withBlockRendering(_Component);

function _PasswordFormComponent(props) {
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            Challenge: props.formData.Password,
            PageId: props.pageId,
            Sub: props.config && props.config.subdomain
        }
        props.onSubmit('/api/challenges', postData, (responseData) => {
            if (responseData.isAuthenticated) {
                props.onComplete();
            } else {
                props.onReset();
                props.onError('Invalid password.')
            }
        });
    }, [props.formData.token])
    const handleFormFieldProps = React.useCallback(({ type }, formFieldProps) => {
        switch (type) {
            case FormField.Password:
                formFieldProps.placeholderText = 'Password *';
                formFieldProps.type = 'password';
                formFieldProps.onSubmit = props.onValidate;
                break;
            case FormField[Name.Block.PasswordForm.Container].ErrorMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.error = props.formData.errorMessage;
                break;
            case FormField[Name.Block.PasswordForm.Container].SubmitButton:
                formFieldProps.formState = props.formData.formState;
                formFieldProps.onClick = props.onValidate;
                break;
        }
    }, [props.formData.errorMessage, props.formData.formState]);

    const contentConfig = Defaults.Block[Name.Block.PasswordForm.Container];
    // let contentConfig = props.contentConfig;
    // if (!contentConfig) {
    //     if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
    //         contentConfig = props.blockConfig.layout.design;
    //     } else {
    //         contentConfig = Defaults.Block[Name.Block.PasswordForm.Container];
    //     }
    // }
    return (
        <FormContainer.Component
            {...props}
            builder={props.builder || props.disabled}
            contentConfig={contentConfig}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const PasswordFormComponent = withValidationV2(_PasswordFormComponent, ['Password']);
const PasswordForm = { Component: PasswordFormComponent };

export {
    Component,
    PasswordForm
}